"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var default_theme_1 = __importDefault(require("../../default-theme"));
var global_1 = __importDefault(require("../../styles/global"));
var LanguageContext_1 = __importDefault(require("./LanguageContext"));
var Provider = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? default_theme_1.default : _b, _c = _a.language, language = _c === void 0 ? 'en-US' : _c, children = _a.children;
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(LanguageContext_1.default.Provider, { value: language },
            children,
            react_1.default.createElement(global_1.default, null))));
};
exports.default = Provider;
//# sourceMappingURL=index.js.map